import Modal from "~/components/modal.tsx";
import useAppDispatch from "~/hooks/use-app-dispatch.ts";
import { closeBasePlatConversionWarning } from "./store-slice.ts";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type BasePlateConversionWarningModalProps = {
	readonly show: boolean;
};

function BasePlateConversionWarningModal({
	show,
}: BasePlateConversionWarningModalProps) {
	const dispatch = useAppDispatch();
	const t = useTranslator();
	const onClose = () => {
		dispatch(closeBasePlatConversionWarning());
	};

	return (
		<Modal
			show={show}
			title={t("Large baseplates are temporarily out of stock")}
		>
			<Modal.Text>
				{t(
					"We switched your design to small baseplates. To increase the size of the mosaic you can add more baseplates.",
				)}
			</Modal.Text>
			<Modal.Actions
				actions={[{ text: t("Close"), onClick: onClose, type: "ghost" }]}
			/>
		</Modal>
	);
}

export default BasePlateConversionWarningModal;
